import { createRequestConstantNames } from 'store/util/createConstants';

export const [
  FETCH_ACCOUNT_DISCOUNTS,
  FETCH_ACCOUNT_DISCOUNTS_SUCCESS,
  FETCH_ACCOUNT_DISCOUNTS_FAIL,
] = createRequestConstantNames('FETCH_ACCOUNT_DISCOUNTS');
